<template>
  <v-card :class="isMobile.isMobile ? 'SimClassWrapMobile' : 'SimClassWrap'">
    <div>
      <div style="width: 100% !important; padding: 0 0">
        <div
          class="header"
          :style="{
            zIndex: '99',
            position: 'relative',
            height: isMobile.isMobile ? '44px' : '64px',
          }"
          v-if="!isMobile.isMobile"
        >
          <div
            class="md-toolbar-row"
            :style="{
              height: isMobile.isMobile ? '44px' : '64px',
              minHeight: isMobile.isMobile ? '44px' : '56px',
            }"
          >
            <div class="md-toolbar-section-start">
              <span class="titleStyle">数字课堂</span>
              <a
                class="ahoverdown"
                :style="{
                  height: isMobile.isMobile ? '44px' : '64px',
                  lineHeight: isMobile.isMobile ? '44px' : '64px',
                }"
              >
                <span
                  class="iconfont icon-xiazai-"
                  style="vertical-align: inherit; margin-right: 4px; font-size: 14px"
                ></span
                >客户端下载
                <div class="downWrap">
                  <div class="item">
                    <div class="itemWrap">
                      <a
                        target="_blank"
                        :href="getDownloadUrl('pc')"
                      >
                        <img src="/pcdown.png" class="img" />
                        <span class="iconfont icon-xiazaidaoru downSpan"></span>
                      </a>
                    </div>
                    <p>【windows、vr、zspace、kmax】</p>
                  </div>
                  <div class="item">
                    <div class="itemWrap">
                      <a
                        target="_blank"
                        :href="getDownloadUrl('android')"
                      >
                        <img src="/azdown.png" class="img" />
                        <span class="iconfont icon-xiazaidaoru downSpan"></span>
                      </a>
                    </div>
                    <p>【安卓】</p>
                  </div>
                </div>
              </a>
            </div>
            <v-spacer></v-spacer>

            <div
              class="md-toolbar-section-end"
              style="text-align: right; width: auto"
              @mousedown="mouseDown"
            >
              <el-cascader
                size="small"
                placeholder="全部"
                @change="onchange"
                v-model="optionsValue"
                :props="cascaderProps"
                id="coursefilterWrap"
                ref="coursefilterWrap"
                :style="{ marginRight: isMobile.isMobile ? '0px' : '30px' }"
                :show-all-levels="true"
              >
                <template slot-scope="{ node, data }">
                  <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
                </template>
              </el-cascader>
            </div>
          </div>
        </div>
      </div>

      <div style="overflow:hidden; margin-right:15px;margin-left:15px;">
        <md-toolbar class="MobileToolbar" :style="{ height: isMobile.isMobile ? '44px' : '56px',minHeight:isMobile.isMobile?'44px':'56px' }">
        <span
              :style="{
                margin: isMobile.isMobile ? '0  ' : '20px',
                width: '80px',
                float: 'left',
                color: '#fff',
                lineHeight:'44px',
                height:'44px'
              }"
              >数字课堂</span
            >

            <!-- ************************************************** -->
            <div
            v-if="!isMobile.isMobile"
              class="md-toolbar-section-end"
              style="text-align: left; width: auto"
              @mousedown="mouseDown"
            >
              <el-cascader
                size="small"
                placeholder="全部"
                @change="onchange"
                v-model="optionsValue"
                :props="cascaderProps"
                id="coursefilterWrap"
                ref="coursefilterWrap"
                :style="{
                  marginRight: isMobile.isMobile ? '0px' : '30px',
                  height: isMobile.isMobile ? '44px' : '56px',
                  lineHeight: isMobile.isMobile ? '44px' : '56px',
                }"
                :show-all-levels="true"
              >
                <template slot-scope="{ node, data }">
                  <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
                </template>
              </el-cascader>
            </div>
            <!-- ************************************************** -->


        <md-button
          class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
          :class="{ toggled: $sidebar.showSidebar }"
          style="float:right;color:#fff !important;"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </md-toolbar>

      </div>

     
      <div
        :style="{
          overflow: 'hidden',
          height: 'auto',
          backgroundColor: ' #fff',
          margin: isMobile.isMobile ? '10px 15px' : '0px',
        }"
      >
        <div class="modelWraps">
          <div
            v-if="isMobile.isMobile"
            style="
              height: 40px;
              width: 100%;
              background-color: #bcbfbc;
              padding-left: 13px;
              padding-right: 13px;
            "
          >
            <a
              class="ahoverdown"
              :style="{
                height: isMobile.isMobile ? '44px' : '64px',
                lineHeight: isMobile.isMobile ? '44px' : '64px',
              }"
              style="z-index: 999999999999"
            >
              <span
                class="iconfont icon-xiazai-"
                style="vertical-align: inherit; margin-right: 4px; font-size: 14px"
              ></span
              >客户端下载
              <div :class="isMobile.isMobile ? 'downWrapIsMobile' : 'downWrap'">
                <div class="item">
                  <div class="itemWrap">
                    <a
                      href="https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2%E5%85%83%E4%B8%96%E7%95%8C%E8%BD%AF%E4%BB%B6V4.8.exe"
                    >
                      <img src="/pcdown.png" class="img" />
                      <span class="iconfont icon-xiazaidaoru downSpan"></span>
                    </a>
                  </div>
                  <p>【windows、vr、zspace、kmax】</p>
                </div>
                <div class="item">
                  <div class="itemWrap">
                    <a
                      href="https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/MetaClass.apk"
                    >
                      <img src="/azdown.png" class="img" />
                      <span class="iconfont icon-xiazaidaoru downSpan"></span>
                    </a>
                  </div>
                  <p>【安卓】</p>
                </div>
              </div>
            </a>
          </div>
          <div class="filterValue">
            <v-text-field
              v-model="searchQuery"
              append-icon="mdi-magnify"
              label="请输入课程名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>
            <md-tooltip md-direction="top">按回车以检索</md-tooltip>
          </div>

          <v-tabs
            v-model="tab"
            color="green"
            class="custom-tab"
            :items="false"
            align-tabs="center"
            style="margin-left: 13px; margin-right: 13px; margin-top: 3px"
          >
            <v-tab :value="item.value" v-for="(item, index) in tabs" :key="index">{{
              item.label
            }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item key="tab-base">
              <!-- 公开课程 -->
              <SimClassCard
                :tabIndex="tab"
                ref="SimClassCard"
                v-if="tab == 0"
                @setcourseListLoading="setcourseListLoading"
              ></SimClassCard>
            </v-tab-item>
            <v-tab-item key="tab-ext">
              <!-- 我的发布 -->
              <SimClassCard
                :tabIndex="tab"
                ref="SimClassCard"
                v-if="tab == 1"
                @setcourseListLoading="setcourseListLoading"
              ></SimClassCard>
            </v-tab-item>
            <v-tab-item key="tab-act"> </v-tab-item>
          </v-tabs-items>
          <!-- v-if="courseListLoading" -->
          <div
            class="md-layout noDataGuJia"
            v-if="courseListLoading&&!isMobile.isMobile"
            :style="{ top: isMobile.isMobile ? '133px' : '58px' }"
          >
            <v-sheet
              v-for="(index, item) in 8"
              :key="index"
              :color="`grey ${item.isDark ? 'darken-2' : 'lighten-4'}`"
              class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 modelClientWrap"
            >
              <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
            </v-sheet>
          </div>

          <!-- v-if="courseListLoading && isMobile.isMobile" -->
          <div
          v-if="courseListLoading && isMobile.isMobile"
          class="noDataGuJia"
            :style="{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              width: isMobile.isMobile ? '100%' : '0',
            }"
        
          >
            <v-col
              v-for="n in 8"
              :key="n"
              cols="6"
              class="nomodelClientWrap md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-45"
              :style="{
                height: isMobile.isMobile ? '100px' : '133px',
                margin: isMobile.isMobile ? '10x 0px' : '5px 0',
                padding: isMobile.isMobile ? '0px' : '',
              }"
            >
              <v-skeleton-loader
                type="card"
                :style="{ height: isMobile.isMobile ? '110px' : '239px' }"
                class="mb-4"
              />
               
            </v-col>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="showQrCodeStatus"
      scrollable
      :overlay="false"
      max-width="200px"
      transition="dialog-transition"
    >
      <v-card>
        <img src="/erweima.png" alt="" style="width: 200px; height: 200px" />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { ProductCard } from '@/components';
import Pagination from '@/components/Pagination/index';
import { listSimulation, updateSort, setcollect } from '@/api/simulation';
import { categoryList } from '../../../api/user';
import { mapGetters } from 'vuex';
import moment from 'moment';
import SimClassCard from '/src/components/Cards/SimClassCard.vue';

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    ProductCard,
    Pagination,
    SimClassCard,
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'course', 'isMobile']),
  },
  watch: {
    optionsValue(val) {
      if (this.$refs.coursefilterWrap && val.length == 3) {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
      if (this.$refs.coursefilterWrap && val.length == 2 && val[1] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }

      if (this.$refs.coursefilterWrap && val.length == 1 && val[0] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
    },
    tab: {
      handler(news) {
        console.log(news);
        window.localStorage.setItem('courseSimTab', news);
      },
    },
  },
  methods: {
    getDownloadUrl(platform) {
      return process.env.VUE_APP_BASE_URL + `/software/download/${platform}`
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    getTab() {
      if (window.localStorage.getItem('courseSimTab')) {
        let tabs = parseInt(window.localStorage.getItem('courseSimTab'));
        this.tab = tabs;
      }
    },
    setcourseListLoading(data) {
      this.courseListLoading = data;
    },
    showErWei() {
      this.showQrCodeStatus = true;
    },
    onClick(data) {
      this.optionsValue = data.path;
      this.$refs.SimClassCard.selectCard(this.optionsValue);

      this.mouseenter(data);
      this.setFilter(data);
    },
    setFilter(data) {
      if (!data) {
        let getNode = document.querySelector('.el-cascader .el-input__inner');
        getNode.style.width = 80 + 'px';
        return;
      }
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';
      if (data.pathLabels && data.pathLabels.length > 0) {
        data.pathLabels.forEach(item => {
          str += item;
        });
      }

      if (str.length <= 5) {
        getNode.style.width = (str.length + 3) * 18 + 'px';
        return;
      }
      if (str.length > 17) {
        getNode.style.width = str.length * 18 + 'px';
        return;
      }
      getNode.style.width = (str.length + 2) * 18 + 'px';
    },
    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
          this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }
    },
    mouseDown() {
      this.tooltipVisible = false;
    },
    onchange(data) {},
    clickcollect(data) {
      let params = {
        isCollect: data.isCollect == 1 ? 0 : 1,
        date: new Date(),
        _id: data._id,
      };
      if (params.isCollect == 0) {
        var date = new Date(2022, 9 - 1, 30, 8, 30);
        params.date = date;
        // params.date.setHours(0); // 将小时部分设置为0
        // params.date.setMinutes(0); // 将分钟部分设置为0
        // params.date.setSeconds(0); // 将秒部分设置为0
        // params.date.setMilliseconds(0); // 将毫秒部分设置为0
      } else if (params.isCollect == 1) {
        params.date = new Date();
      }

      setcollect(params).then(res => {
        if (res.code == '200') {
          data.isCollect = data.isCollect == 1 ? 0 : 1;
          this.$notify({
            timeout: 1500,
            message: params.isCollect ? '收藏成功' : '取消收藏',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          // this.pagination.page = 1;
          // this.findList();
        }
      });
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    //跳转页面
    gotoDetail(item) {
      this.$router.push({
        path: '/SimClassDetails',
        query: {
          _id: item._id,
          type: 'simclass',
        },
      });

      // var NewUrl = window.location.origin+'/simClassDetails';

      // window.open(NewUrl,'_blank','width=' + screen.width + ', height=' + screen.height + ', top=0, left=0, toolbar=no, menubar=no, location=no, status=no, help=no, center=yes, scrollbars=yes, resizable=yes, minmizebutton=yes, maxmizebutton=yes');
    },

    //添加过滤条件
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.$refs.SimClassCard.setSearchQuery(this.searchQuery);
      }
    },

    async openClient(item, platform = 'PC') {
      if (!['VR', 'PC'].includes(platform)) return;
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.courseId ?? item.project.course,
          projectId: item.project ? item.project._id : '',
          version: item.version,
          platform,
          simulationId: item._id,
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      location.href = `MetaSpaceProject://${params}`;
    },
    // openClass: function () {
    //   window.open("./simclassdetail", "_blank");
    // },
    // findList() {
    //   listSimulation({
    //     status: 1,
    //     perPage: this.pagination.itemsPerPage,
    //     currentPage: this.pagination.page,
    //     refer: this.optionsValue[0]==''?'all':this.optionsValue[0] || '',
    //     majorGroup: this.optionsValue[1]=='all'?'':this.optionsValue[1] || '',
    //     majorGroup2: this.optionsValue[2]=='all'?'':this.optionsValue[2] || '',
    //     name: this.searchQuery || '',
    //   }).then(res => {
    //     this.courseListLoading = false;
    //     this.simulationList = res.data.rows;
    //     this.pagination.total = res.data.total;
    //   }).catch((err)=>{
    //       this.courseListLoading = false;
    //   });
    // },
  },
  data() {
    return {
      tabs: [
        {
          label: '所有课程',
          value: '0',
        },
        {
          label: '我的发布',
          value: '1',
        },
      ],
      tab: 0,
      courseListLoading: false,
      showQrCodeStatus: false,
      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;
          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  code: 'all',
                  name: '全部',
                  level: 0,
                  leaf: true,
                  children: [],
                },
                // { code: 'bjrs', name: '毕节人社', level: 0, leaf: false },
                { code: 'bk', name: '本科', level: 0, leaf: false },
                { code: 'gz', name: '高职', level: 0, leaf: false },
                { code: 'zz', name: '中职', level: 0, leaf: false },
                { code: 'gj', name: '技师学院', level: 0, leaf: false },
                { code: 'jx', name: '技校', level: 0, leaf: false },
                { code: 'qy', name: '企业', level: 0, leaf: false },
              ];

              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data &&
                    res.data.forEach(item => {
                      item.leaf = false;
                    });
                  if (params.cate_type !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '123456',
                      children: [],
                      leaf: true,
                      level: 1,
                    });
                  }
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              let params = {
                cate_type: node.parent.value || '',
                level: '2',
                parentCode: node.value || '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  if (params.parentCode !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '111111111111111',
                      children: [],
                      leaf: true,
                      level: 2,
                    });
                  }

                  resolve(res.data);
                }
              });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },
      tooltipVisible: false,
      tooltipValue: '全部',

      activeValue: '已发布',
      btns: [
        {
          name: '全部',
          value: 0,
        },
        {
          name: '已发布',
          value: 1,
        },
        {
          name: '建设中',
          value: 2,
        },
      ],

      items: [
        {
          name: '全部',
          value: 0,
        },
        {
          name: '已发布',
          value: 1,
        },
        {
          name: '建设中',
          value: 2,
        },
      ],
      // 分页
      // pagination: {
      //   page: 1,
      //   itemsPerPage: 8,
      //   total: 0,
      // },
      product1: './img/bdz.png',
      product2: './img/plc.png',
      product3: './img/jzjk.png',
      seq2: 0,
      simulationList: [],
      searchQuery: '',
    };
  },
  created() {
    this.getTab();
  },
  mounted() {
    // this.findList();
    this.setFilter();
    // this.setCard();
  },
};
</script>

<style lang="css" scoped>
.stats {
  color: #000;
}

.openClient {
  position: absolute;
  right: 0;
  top: 0;
  margin: auto;
  bottom: 0px;
  width: auto;
  /* border-radius: 5px; */
  height: 25px;
  line-height: 25px;
  z-index: 888;
  cursor: pointer;
  /* background-image: url('../../../assets/img/openClient.png'); */
  /* background-repeat: no-repeat; */
  /* background-size: 100% 100%; */
}

.sortNum {
  position: absolute;
  right: 50px;
  top: 0;
  margin: auto;
  bottom: 9px;
  width: 32px;
  border-radius: 5px;
  height: 32px;
  z-index: 888;
  cursor: pointer;
  /* background-image: url("../../../assets/img/openClient.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}

.openClient:hover {
  transform: scale(1.1);
}

.img {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}

.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

/*  overflow: hidden;*/
.header {
  background: #4caf50 !important;
  height: 64px;

  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  margin: 0px 0px 0px 0px;
}

.ahoverdown:hover .downWrap {
  display: block;
}

.downWrap {
  display: none;
  height: auto;
  position: absolute;
  z-index: 999999;
  top: 65px;
  width: 298px;
  left: 70px;
  cursor: pointer;

  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.ahoverdown:hover .downWrapIsMobile {
  display: block;
}
.downWrapIsMobile {
  display: none;
  height: auto;
  position: absolute;
  z-index: 999999;
  top: 45px;
  width: 298px;
  left: 20px;
  cursor: pointer;

  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.downWrapIsMobile:before {
  display: block;
  content: '';
  position: absolute;
  top: -20px;
  width: 0;
  left: 20px;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid #e4e4e4;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  z-index: 999999;
}

.downWrap:before {
  display: block;
  content: '';
  position: absolute;
  top: -20px;
  width: 0;
  left: 110px;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid #e4e4e4;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  z-index: 999999;
}

.item {
  float: left;
  height: 90px;
  width: 186px;
  transition: 0.5s;
  padding: 0 5px;
}

.item p {
  transition: 0.5s;
  color: #000;
  width: 186px;
  height: auto;
}
.item:last-child {
  width: 106px;
}
.item:last-child p {
  width: 95px;
}

.itemWrap a {
  display: block;
  width: 100%;
  height: 50px;
}

.item .itemWrap {
  height: 40px;
  width: 40px;
  margin: 0 auto;
  box-shadow: 0 2px 7px rgb(165, 190, 166);
  border-radius: 6px;
  margin: 10px auto;
  position: relative;
  background: #fff;
}

.item .itemWrap img {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto !important;
  width: 30px;
  height: 30px;
}

.downSpan {
  color: #4caf50;
}

.item .itemWrap .downSpan {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto !important;
  font-size: 0px;
  width: 0px;
  height: 0px;
  text-align: center;
}

.itemWrap:hover .img {
  width: 0px;
  height: 0px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto !important;
  transition: 0.3s;
  opacity: 0;
  overflow: visible;
}
.item .itemWrap:hover .downSpan {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: 0.3s;
  margin: auto !important;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  text-align: center;
}

.item p {
  height: 19px;
  font-size: 12px;
  text-align: center;
  margin: 0px;
  margin-top: -2px;
}

.queryWrap {
  margin-top: 7px;
}

#coursefilterWrap {
  /* margin-top: 10px; */
  margin-left: 10px;
  /* margin-right: 30px; */

  /* width: 320px; */
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}
.filterCoure {
  font-weight: 700;
}


.MobileToolbar {
  display: none;
}
@media (max-width: 600px) {
  .MobileToolbar {
    display: block;
    background: #4caf50 !important;
    /* display: flex;
    justify-content: space-around;
    align-items: center; */
    /* margin-right: 15px; */

    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12);
    margin: 10px 0px 0px;
    /* margin: 0px 0px 0px 0px; */
    /* padding: 10px 10px; */
  }
  .pcToolbar {
    display: none;
  }
}

@media (max-width: 600px) {
  .titleStyle {
    margin: 0px 0px 0px 10px !important;
  }
  .filterValue {
    width: 100%;
    margin-top: 10px;
    padding-right: 16px;
    padding-left: 16px;
  }
  .ahoverdown {
    width: 95px;
  }
  .noDataGuJia {
    width: 100%;
    position: absolute;
    top: 130px;

  }
  .SimClassWrap {
    margin-left: 13px;
    margin-right: 13px;
  }

  .nomodelClientWrap{
    margin: 10px 0;
    width: 45%;
  }



  .nomodelClientWrap:nth-child(odd){
    margin-left: 10px;
  }

  .nomodelClientWrap:nth-child(even){
    margin-right: 10px;
  }
}

@media (min-width: 600px) {
  .filterValue {
    margin: 0 auto;
    width: 300px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 900;
    padding-left: 16px;
    padding-right: 16px;
  }
}


</style>
<style >
/* 设置滚动条层级最高 */
.main-panel .ps__rail-y {
  z-index: 99 !important;
}
.custom-tab {
  margin-left: 0px;
  margin-right: 0px;
}
.modelWraps {
  position: relative;
  overflow: hidden;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  /* min-height: 660px; */
}
.filterValue {
  margin: 0 auto;
  width: 300px;
  /* position: absolute;
  top: 10px;
  right: 10px; */
  z-index: 900;
}

.filterValue .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.modelClientWrap {
  padding-left: 10px;
  padding-right: 10px;
}

.titleStyle {
  width: 80px;
  float: left;
  color: #fff;
  margin: 20px 10px 20px 26px;
}

.ahoverdown {
  color: #fff !important;
  font-size: 14px;
  z-index: 9999999;
  height: 64px;
  line-height: 64px;
}

.noDataGuJia {
  overflow: hidden;
  width: 100%;
  height: auto;
  position: absolute;
  top: 55px;
  z-index: 99;
}

.SimClassWrapMobile {
  box-shadow: none !important;
  background: transparent !important;
}
.SimClassWrap {
  margin-left: 13px;
}


</style>
